module.exports = __webpack_public_path__ + "img/past-events_rose-bowl.78d10b8b.jpg";